<script>
   export let id;
</script>

<iframe title="{id}" src="{"/apps/" + id + "/index.html"}" width="100%" height="100%">Loading</iframe>

<style>
   iframe {
      border: none;
      width: 100%;
      height: 100%;
   }
</style>